module.exports = __webpack_public_path__ + "img/disabled2.a778586a.jpg";